import { render, staticRenderFns } from "./FpuiPackages.vue?vue&type=template&id=ba012dfa&lang=pug&"
import script from "./FpuiPackages.vue?vue&type=script&lang=js&"
export * from "./FpuiPackages.vue?vue&type=script&lang=js&"
import style0 from "./FpuiPackages.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports